import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { MeetingService } from '../../../services/MeetingService';
import { GetMeetingListPagingAndFilterRequest, initialGetMeetingListPagingAndFilterRequest } from '../../../models/request/meeting/GetMeetingListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetMeetingListPagingAndFilterResponse, GetMeetingListPagingAndFilterResponseData, GetMeetingListPagingAndFilterResponseItem, initialGetMeetingListPagingAndFilterResponseData } from '../../../models/response/meeting/GetMeetingListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { GetConstantListResponse, GetConstantListResponseItem } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import MeetingListFilters from './Components/MeetingListFilters';
import { ExportMeetingListResponse } from '../../../models/response/meeting/ExportMeetingListResponse';
import { DeleteMeetingResponse } from '../../../models/response/meeting/DeleteMeetingResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import moment from 'moment';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const MeetingList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Pazarlama > Görüşmeler"
    const pageVersion = "1";
    const [data, setData] = useState<GetMeetingListPagingAndFilterResponseData>(initialGetMeetingListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetMeetingListPagingAndFilterRequest>(initialGetMeetingListPagingAndFilterRequest);
    const [isFirstTime, setIsFirstTime] = useState(true);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Görüşme Tarihi', name: 'meetingDate', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'selectedCompanyName', order: 0, isVisible: true },
            { title: 'Yetkili Kişi', name: 'selectedPersonAuthorizedPersonName', order: 0, isVisible: true },
            { title: 'Yetkili Telefon', name: 'selectedPersonAuthorizedPersonPhone', order: 0, isVisible: true },
            { title: 'Görüşme Şekli', name: 'meetingTypeName', order: 0, isVisible: true },
            { title: 'Firma Durumu', name: 'initialCompanyTypeName', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteMeeting = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.meetingId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteMeetingResponse = await MeetingService.deleteMeeting(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateMeeting = async (_id: string | undefined = undefined) => {
        navigate('/meeting/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].meetingId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetMeetingListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            dispatch(storeActivityIndicator(true))

            if (isFirstTime) {
                // Açılışta eski filtre panelindeki varsayılanlar kolon filtresi olarak kurulur:
                // son bir aylık görüşmeler ve varsayılan firma durumu (AdditionalValue1 = "1").
                var defaultColumnFilters: ColumnFilterModel[] = [
                    { column: 'meetingDate', from: moment(new Date()).subtract(1, 'month').format("YYYY-MM-DD"), to: moment(new Date()).format("YYYY-MM-DD") }
                ];

                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, "1");

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0)
                    defaultColumnFilters.push({ column: 'initialCompanyTypeName', values: [response5.data[0].constantId], valueLabels: [response5.data[0].value + ''] });

                if (!_filter)
                    _filter = { ...filter, columnFilters: defaultColumnFilters };

                setIsFirstTime(false);
            }

            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            var response: GetMeetingListPagingAndFilterResponse = await MeetingService.getMeetingListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.meetingId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportMeetingListResponse = await MeetingService.exportMeetingList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.meetingId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi listede yok.
    // Görüşme tarihi ekranda biçimlendirilse de gerçek tarih alanına göre sıralanır.
    const sortableColumns = [
        'refNo', 'meetingDate', 'selectedCompanyName',
        'selectedPersonAuthorizedPersonName', 'selectedPersonAuthorizedPersonPhone',
        'meetingTypeName', 'initialCompanyTypeName'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (MeetingManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        meetingDate: { type: 'date' },
        selectedCompanyName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        selectedPersonAuthorizedPersonName: { type: 'text' },
        selectedPersonAuthorizedPersonPhone: { type: 'text' },
        meetingTypeName: { type: 'select', loadOptions: () => loadConstants('MEETING_TYPE') },
        // Görüşülen firmanın firma durumu (Potansiyel Müşteri vb.).
        initialCompanyTypeName: { type: 'select', loadOptions: () => loadConstants('MEETING_COMPANY_TYPE'), renderOption: (label) => <StatusBadge text={label} /> },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetMeetingListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.meetingId)} onDoubleClick={() => updateMeeting(item.meetingId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.meetingId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.meetingId)} onDoubleClick={!item.companyId ? undefined : () => updateMeeting(item.meetingId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.meetingId)} onDoubleClick={!item.companyId ? undefined : () => updateMeeting(item.meetingId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (column == "initialCompanyTypeName") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.meetingId)} onDoubleClick={!item.companyId ? undefined : () => updateMeeting(item.meetingId)}><StatusBadge text={item.initialCompanyTypeName} /></td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.meetingId)} onDoubleClick={!item.companyId ? undefined : () => updateMeeting(item.meetingId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <MeetingListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    data={data}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteMeeting}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateMeeting}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.meetingId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default MeetingList;